import Hello from './HelloWorld.vue'

export default Hello